import { Link, useLocation } from "react-router-dom";
import { styles } from "../shared.styles";

interface PreserveParamsLinkProps {
  /**
   * The target URL to navigate to while preserving search parameters.
   */
  to: string;
  /**
   * Children elements to be rendered inside the link.
   */
  children?: React.ReactNode;
  [key: string]: any;
}

/**
 * A link component that preserves URL search parameters when navigating.
 */
const PreserveParamsLink: React.FC<PreserveParamsLinkProps> = ({
  to,
  children,
  className,
  ...props
}) => {
  const { search } = useLocation();
  return (
    <Link
      to={`${to}${search}`}
      className={`${styles.link} ${className}`}
      {...props}
    >
      {children}
    </Link>
  );
};

export default PreserveParamsLink;
